/**
 * Lightweight check for mobile browsers (Android / iOS).
 *
 * Used to enable mobile-specific workarounds such as skipping the
 * `getUserMedia` audio track to avoid conflicts with `SpeechRecognition`.
 */
export function isMobileBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  return /Android|iPhone|iPad|iPod/i.test(navigator.userAgent);
}
